import { useTranslation } from 'react-i18next';

const ALOLAN = 904;
const GALAR = 933;

const pokemonName = props => {
    // eslint-disable-next-line
    const [t, i18n] = useTranslation();

    const getFullName = (species, formidx) => {
        const idxn = formidx + (formidx > 967? 9 : formidx > 961? formidx + 8 : formidx > 898 ? 5 : 0);
        const formName = t("form." + idxn);
        if (formName.length > 0) {
            return t("pokemon." + species) + " (" + formName + ")";
        }
        return t("pokemon." + species);
    }

    const GetAlolanForm = (species, form) => {
        if(species === 52) {
            if(form === 1) getFullName(species, ALOLAN);
            if(form === 2) getFullName(species, GALAR);
        }
        if([19, 20, 26, 27, 28, 37, 38, 50, 51, 53, 74, 75, 76, 88, 89, 103, 105].indexOf(species) !== -1) {
            if(form > 0) {
                return getFullName(species, ALOLAN);
            }
        }

        return t("pokemon." + species);
    }

    const GetFormsGen1 = (species, form) => {
        if(species === 25) {
            return getFullName(species, form + 906);
        }
        if([77, 78, 79, 80, 83, 110, 122].indexOf(species) !== -1) {
            if(form > 0) {
                return getFullName(species, GALAR);
            }
        }
        
        return GetAlolanForm(species, form);
    }

    const GetFormsGen2 = (species, form) => {
        if(species === 222) {
            if(form > 0) {
                return getFullName(species, GALAR);
            }
        }
        return t("pokemon." + species);
    }

    const GetFormsGen3 = (species, form) => {
        if([263, 264].indexOf(species) !== -1) {
            if(form > 0) {
                return getFullName(species, GALAR);
            }
        }

        if(species === 351) {
            return getFullName(species, form + 1006);
        }

        if([382, 383].indexOf(species) !== -1) {
            return getFullName(species, 1017);
        }

        if(species === 386) {
            return getFullName(species, form + 1019);
        }

        return t("pokemon." + species);
    }

    const GetFormsGen4 = (species, form) => {
        if([412, 413, 414].indexOf(species) !== -1) {
            return getFullName(species, form + 1022);
        }
        
        if(species === 421) {
            return getFullName(species, 1029);
        }

        if([422, 423].indexOf(species) !== -1) {
            return getFullName(species, 1030);
        }

        if(species === 479) {
            return getFullName(species, 1036 + form);
        }

        if(species === 487) {
            return getFullName(species, 1042);
        }
        
        if(species === 492) {
            return getFullName(species, 1043);
        }

        return t("pokemon." + species);
    }

    const GetFormsGen5 = (species, form) => {
        if(species === 550) {
            return getFullName(species, 1063);
        }

        if([554, 555, 562, 618].indexOf(species) !== -1) {
            return getFullName(species, GALAR);
        }

        if([585, 586].indexOf(species) !== -1) {
            return getFullName(species, form + 1069);
        }

        if([641,642,645].indexOf(species) !== -1) {
            return getFullName(species, 1079);
        }

        if(species === 646) {
            return getFullName(species, 1081+form);
        }

        if(species === 647) {
            return getFullName(species, 1084);
        }

        if(species === 648) {
            return getFullName(species, 1085);
        }

        return t("pokemon." + species);
    }

    const GetFormsGen6 = (species, form) => {
        if([664, 665, 666].indexOf(species) !== -1) {
            return getFullName(species, form + 1129);
        }

        if([669, 670, 671].indexOf(species) !== -1) {
            return getFullName(species, form + 1152);
        }

        if(species === 676) {
            return getFullName(species, 1161 + form);
        }

        if(species === 678) {
            return getFullName(species, 1171);
        }

        if(species === 681) {
            return getFullName(species, 1172);
        }
        
        if([710, 711].indexOf(species) !== -1) {
            return getFullName(species, 1172 + form);
        }

        if(species === 716) {
            return getFullName(species, 1179);
        }

        if(species === 718) {
            return getFullName(species, 1179 + form);
        }

        if(species === 720) {
            return getFullName(species, 1185);
        }

        return t("pokemon." + species);
    }

    const GetFormsGen7 = (species, form) => {
        if(species === 741) {
            return getFullName(species, 1187 + form);
        }

        if(species === 744) {
            return getFullName(species, 1194);
        }

        if(species === 745) {
            return getFullName(species, 1192 + form);
        }

        if(species === 746) {
            return getFullName(species, 1195);
        }

        if(species === 773) {
            return getFullName(species, 1198 + form);
        }

        if(species === 774) {
            return getFullName(species, 1115 + form);
        }

        if(species === 778) {
            return getFullName(species, 1230);
        }

        if(species === 800) {
            return getFullName(species, 1233 + form);
        }

        if(species === 801) {
            return getFullName(species, 1237);
        }

        return t("pokemon." + species);
    }

    const GetFormsGen8 = (species, form) => {
        if(species === 845) {
            return getFullName(species, 1248 + form);
        }

        if(species === 849) {
            return getFullName(species, 1251);
        }

        if(species === 869) {
            return getFullName(species, 1257 + form);
        }

        if(species === 875) {
            return getFullName(species, 1267);
        }

        if(species === 877) {
            return getFullName(species, 1269);
        }

        if(species === 892) {
            return getFullName(species, 1276);
        }

        if(species === 893) {
            return getFullName(species, 1279);
        }

        return t("pokemon." + species);
    }

    if(props.form === 0) {
        return getFullName(props.id, props.id);
    } else {
        // handle special cases
        if (props.id <= 151)
            return GetFormsGen1(props.id, props.form);
        if (props.id <= 251)
            return GetFormsGen2(props.id, props.form);
        if (props.id <= 386)
            return GetFormsGen3(props.id, props.form);
        if (props.id <= 493)
            return GetFormsGen4(props.id, props.form);
        if (props.id <= 649)
            return GetFormsGen5(props.id, props.form);
        if (props.id <= 721)
            return GetFormsGen6(props.id, props.form);
        if (props.id <= 807)
            return GetFormsGen7(props.id, props.form);
        return GetFormsGen8(props.id, props.form);
    }
}

export default pokemonName;